import { DocumentNode, gql } from '@apollo/client'

export const GET_DAYCARE_GROUPS: DocumentNode = gql`
    query GetDaycareGroups {
        getDaycareGroups {
            country
            id
            location
            name
            active
            created
            trustees {
                address
                city
                country
                email
                firstname
                id
                lastname
                phone
                zip
                userId
                main
                canWrite
            }
            colors {
                daycareDark
                daycareMain
                daycareLight
                daycareExtraLight
                parentDark
                parentMain
                parentLight
                parentExtraLight
            }
            downloadParams {
                canDownloadImages
                canDownloadDocuments
            }
            logoBase64Data
            daycarePSU
            type
            daycares {
                id
                active
                staffAccess
                type
                name
                manager
                email
                phone
                address
                city
                zip
                country
                bookMin
                bookWeeklyLimit
                bookRange
                autoLink
                autoLinkEnable
                internalAutoLink
                internalAutoLinkEnable
                externalAutoLink
                externalAutoLinkEnable
                trusteeWrite
                merger
                created
                updated
                validityEnd
                timezone
                activeAlert
                alertRange
                alertComment
                mailSignature
                staffCount
                expirationDuration
                newsAccess
                suggestAccess
                taskNoteAccess
                mealAccess
                colors {
                    daycareDark
                    daycareMain
                    daycareLight
                    daycareExtraLight
                    parentDark
                    parentMain
                    parentLight
                    parentExtraLight
                }
                logoBase64Data
                accessibility {
                    id
                    type
                    start
                    end
                }
                staffLink {
                    notifReport
                    notifNewParent
                    notifPushNewParent
                    notifUpdateParent
                    notifPushUpdateParent
                    notifNewStaff
                    notifPushNewStaff
                    notifConfirmation
                    notifPushConfirmation
                    notifCancellation
                    notifPushCancellation
                    notifRequestSlot
                    notifPushRequestSlot
                    notifEventDays
                    notifPushEventDays
                    notifTaskNote
                    notifPushTaskNote
                    notifRegularSlot
                    notifPushRegularSlot
                    level
                    rw_params_daycare
                    rw_staffs
                    rw_staff_work
                    rw_families
                    rw_child
                    rw_occasional_slot
                    rw_request_slot
                    rw_regular_slot
                    rw_news
                    rw_event_days
                    rw_closing_days
                    w_add_posts
                    rw_suggestions
                    rw_task_note
                    rw_meal
                }
                opening {
                    monOpen
                    monClose
                    monBreakStart
                    monBreakEnd
                    tueOpen
                    tueClose
                    tueBreakStart
                    tueBreakEnd
                    wedOpen
                    wedClose
                    wedBreakStart
                    wedBreakEnd
                    thuOpen
                    thuClose
                    thuBreakStart
                    thuBreakEnd
                    friOpen
                    friClose
                    friBreakStart
                    friBreakEnd
                    satOpen
                    satClose
                    satBreakStart
                    satBreakEnd
                    sunOpen
                    sunClose
                    sunBreakStart
                    sunBreakEnd
                }
                groups {
                    id
                    name
                }
                sections {
                    id
                    max
                    name
                    sectionGroupId
                }
                sectionsGroups {
                    id
                    name
                    sections
                    rate
                }
                levels {
                    id
                    name
                    required
                }
                colors {
                    daycareDark
                    daycareMain
                    daycareLight
                    daycareExtraLight
                    parentDark
                    parentMain
                    parentLight
                    parentExtraLight
                }
                predefinedMessages {
                    type
                    message
                }
                releaseParameters {
                    releaseActivation
                    releaseWeekCountBefore
                    releaseDayCountBefore
                    releaseDay
                    releaseHour
                }
                haveDaycareGroup
            }
        }
    }
`

export const CREATE_DAYCARE_GROUP: DocumentNode = gql`
    mutation CreateDaycareGroup($group: DaycareCreateGroupInput!, $trustee: DaycareTrusteeInput!) {
        createDaycareGroup(group: $group, trustee: $trustee)
    }
`

export const UPDATE_DAYCARE_GROUP: DocumentNode = gql`
    mutation UpdateDaycareGroup($group: DaycareUpdateGroupInput!, $groupId: Int!) {
        updateDaycareGroup(groupId: $groupId, group: $group)
    }
`

export const DELETE_DAYCARE_GROUP: DocumentNode = gql`
    mutation DeleteDaycareGroup($groupId: Int!) {
        deleteDaycareGroup(groupId: $groupId)
    }
`

export const UPDATE_DAYCARE_GROUP_ACTIVE: DocumentNode = gql`
    mutation UpdateDaycareGroupActive($groupId: Int!, $active: Boolean!) {
        updateDaycareGroupActive(groupId: $groupId, active: $active)
    }
`

export const UPDATE_DAYCARE_GROUP_COLORS: DocumentNode = gql`
    mutation UpdateDaycareGroupColors($groupId: Int!, $colors: DaycareColorsInput!) {
        updateDaycareGroupColors(groupId: $groupId, colors: $colors)
    }
`

export const UPDATE_DAYCARE_GROUP_DOWNLOAD_PARAMS: DocumentNode = gql`
    mutation UpdateDaycareGroupDownloadParams($groupId: Int!, $params: DaycareGroupDownloadInput!) {
        updateDaycareGroupDownloadParams(groupId: $groupId, params: $params)
    }
`

export const DELETE_DAYCARE_GROUP_LOGO: DocumentNode = gql`
    mutation DeleteDaycareGroupLogo($groupId: Int!) {
        deleteDaycareGroupLogo(groupId: $groupId)
    }
`

export const ADD_DAYCARE_GROUP_LOGO: DocumentNode = gql`
    mutation AddDaycareGroupLogo($groupId: Int!, $file: Upload!, $width: Int, $height: Int) {
        addDaycareGroupLogo(groupId: $groupId, file: $file, width: $width, height: $height)
    }
`
